var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-btn c-btn--add-to-cart u-mrs c-btn--lg",attrs:{"type":"button"},on:{"click":_vm.onAddToCartFromTomPremiumSummary}},[_vm._v("Great! Add to Cart")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }